<template>
  <b-input-group
    id="date-range-picker-container"
    :class="{ border: isBorder }"
    @click="openDateRangePicker"
  >
    <datepicker
      v-model="dateRange"
      :config="config"
      placeholder="Select Date Range"
    >
    </datepicker>
    <b-input-group-append>
      <i class="bi mr-2" :class="icon" aria-hidden="true"></i>
      <i
        v-if="showClearButton && dateRange && dateRange.includes('to')"
        class="bi bi-x-circle cursor-pointer"
        @click.stop="clearDates"
      ></i>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import { DateTime } from "luxon";

const currentDate = DateTime.now().toFormat("yyyy-LL-dd");

export default {
  props: {
    value: {
      type: String,
    },
    showClearButton: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: currentDate,
    },
    icon: {
      type: String,
      default: "bi-chevron-down",
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
  },
  components: { Datepicker },
  data() {
    return {
      dateRangePicker: null,
      dateRange: "",
      currentDate,
    };
  },
  methods: {
    openDateRangePicker() {
      this.dateRangePicker.open();
    },
    clearDates() {
      if (this.dateRangePicker) {
        this.dateRangePicker.clear();
        this.dateRange = "";
        this.$emit("clearDateRange");
      }
    },
  },
  computed: {
    config() {
      const _this = this;

      return {
        altInput: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        static: true,
        mode: "range",
        minDate:
          this.minDate < this.currentDate ? this.minDate : this.currentDate,
        onReady: function (_, __, instance) {
          _this.dateRangePicker = instance;
        },
      };
    },
  },
  watch: {
    dateRange(newValue, oldValue) {
      if (oldValue) this.$emit("onTouchData");

      let from = "";
      let to = "";

      if (newValue && newValue.includes("to")) {
        const dates = newValue.split(" to ");
        from = dates[0];
        to = dates[1];
      }

      this.$emit("onDateRangeChange", {
        from,
        to,
      });
    },
  },
  created() {
    this.dateRange = this.value;
  },
};
</script>

<style lang="scss">
#date-range-picker-container {
  min-width: 240px;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 #e3e3e3;
  .flatpickr-wrapper {
    flex: 1;
    & > .form-control {
      background: transparent;
      border: 0;
      border-radius: 0;
      box-shadow: none;
      color: #2a2a2a;
      font-family: MainFontBold, sans-serif;
      font-size: 13px;
    }
    .flatpickr-current-month {
      font-size: 100%;
    }
    .flatpickr-input {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
  .input-group-prepend,
  .input-group-append {
    padding: 0 10px 0 0;
    display: flex;
    align-items: center;
    .input-group {
      box-shadow: none;
    }
  }
}
</style>
